"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.looseMatch = exports.normalize = void 0;
const normalize = (value) => value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/ /g, "");
exports.normalize = normalize;
const looseMatch = (search, value) => {
    if (search.length === 0)
        return true;
    const valueN = exports.normalize(value);
    const searchN = exports.normalize(search);
    let pos = 0;
    for (let i = 0; i < valueN.length; i++) {
        if (pos < searchN.length && valueN[i] === searchN[pos]) {
            pos++;
            if (pos === searchN.length) {
                return true;
            }
        }
    }
    return false;
};
exports.looseMatch = looseMatch;
//# sourceMappingURL=search.js.map